import ListingFullDisplayPlaceHolder from "components/v3/Listings/ListingFullDisplay/ListingFullDisplayPlaceHolder";
// import ListingFullDisplay from "components/v3/Listings/ListingFullDisplay";
import PROXY_CONFIG from "Config/ProxyConfig";
import dynamic from "next/dynamic";
import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "../../../redux/slices/v2/ListingReducer";
import api_call_v2 from "../../../utils/API_CALL/api_call_v2";
import $ from "utils/selectors";
const LoginRegisterDialog = dynamic(
  () => import("components/LoginRegisterDialog"),
  {
    suspense: false,
    ssr: false,
  }
);
const ListingFullDisplay = dynamic(
  () => import("components/v3/Listings/ListingFullDisplay"),
  {
    suspense: true,
    ssr: true,
  }
);
type ListingDisplayContainerProps = {
  annonceSlug?: string;
  annonce?: any;
  agence?: any;
  h1Type?: any;
  viewType: "Vente" | "Location" | "Projets Neufs" | "";
  annoncesSimilaires?: any;
};

export default function ListingDisplayContainer({
  annonceSlug,
  annonce,
  viewType,
  agence,
  h1Type,
  annoncesSimilaires,
}: ListingDisplayContainerProps) {
  const dispatch = useDispatch();
  const currentListing = useSelector(
    ListingreducerSelectors.currentListingSelactor
  );

  const searchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  const favListings = useSelector(
    ListingreducerSelectors.favoriteListingsSelactor
  );
  const mapVsList = useSelector(ListingreducerSelectors.mapVsListSelactor);

  // useEffect(() => {
  //   dispatch(
  //     ListingreducerActions.setCurrentListing({
  //       currentListing: { ...annonce, agence },
  //     })
  //   );
  // }, []);

  const [rendring, setRendering] = useState<"CLIENT_SIDE" | "SERVER_SIDE">(
    "SERVER_SIDE"
  );

  const [isFav, setFav] = useState(favListings.includes(currentListing?._id));
  const [loadingLike, setLoadingLike] = useState(false);

  const [isAuthDialogVisible, setAuthDialogVisible] = useState(false);

  useEffect(() => {
    setFav(favListings.includes(currentListing?._id));
  }, [favListings.includes(currentListing?._id)]);

  const onFavoriteIconPress = (listingId: string) => {
    const FBIdToken = localStorage.FBIdToken;
    if (FBIdToken) {
      setLoadingLike(true);
      if (favListings.includes(listingId)) {
        api_call_v2(
          undefined,
          "post",
          "deleteFavoris",
          { listingId: listingId },
          "cloud_functions",
          true
        )
          .then((res) => {
            dispatch(
              ListingreducerActions.setFavListing({
                favListings: favListings.filter((item) => item !== listingId),
              })
            );
            setFav(false);
            setLoadingLike(false);
          })
          .catch((err) => {
            setLoadingLike(false);
            setFav(false);
          });
      } else {
        api_call_v2(undefined, "post", "addFavoris", {
          listingId: listingId,
        })
          .then((res) => {
            dispatch(
              ListingreducerActions.setFavListing({
                favListings: [...favListings, listingId],
              })
            );
            setLoadingLike(false);
            setFav(true);
          })
          .catch((err) => {
            setLoadingLike(false);
            setFav(false);
          });
      }
    } else {
      setAuthDialogVisible(true);
    }
  };
  useEffect(() => {
    if (window.innerWidth < 990) {
      if (!currentListing) {
        $("body").css("height", "100%");
        $("body").css("overflow", "hidden");
      } else {
        $("body").css("height", "auto");

        $("body").css("overflow", "scroll");
      }
    }
  }, [currentListing]);
  useEffect(() => {});
  return (
    <>
      {isAuthDialogVisible && (
        <Suspense fallback={<></>}>
          <LoginRegisterDialog
            visible={isAuthDialogVisible}
            bodyScrollonClose={true}
            onClose={() => {
              setAuthDialogVisible(false);
            }}
            onFacebookSignInSuccess={() => {
              setAuthDialogVisible(false);
            }}
            onGoogleSignInSuccess={() => {
              setAuthDialogVisible(false);
            }}
            onRegisterSucccess={() => {
              setAuthDialogVisible(false);
            }}
            onSignInSuccess={() => {
              setAuthDialogVisible(false);
            }}
            onSwitchSignType={() => {
              return;
            }}
            Estimation={false}
          />
        </Suspense>
      )}
      {currentListing ? (
        <Suspense fallback={<ListingFullDisplayPlaceHolder />}>
          <ListingFullDisplay
            listing={currentListing}
            transaction_type={
              rendring === "SERVER_SIDE"
                ? viewType
                : searchPayload.transaction_type
            }
            onFavoriteIconPress={onFavoriteIconPress}
            setAuthDialogVisible={() => {
              setAuthDialogVisible(!isAuthDialogVisible);
            }}
            loadingLike={loadingLike}
            liked={isFav}
            annoncesSimilaires={annoncesSimilaires}
            agence={agence}
            h1Type={h1Type}
            onClose={() => {
              if (mapVsList === "MAP" && window.innerWidth < 990) {
                $("body").css("height", "100%");
                $("body").css("overflow", "hidden");
              }

              dispatch(
                ListingreducerActions.setCurrentListing({
                  currentListing: null,
                })
              );
            }}
          />
        </Suspense>
      ) : null}
    </>
  );
}
